export default "https://cdn-static.gokick.com/assets/c736ccdc0086f37925b8733f1854c980393ad61e/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";